import type { Transformer } from "@/Common/Models/Domain/Transformer";
import { type BotQuestionApi, BotQuestionTypeApi } from "../../../Models/Api/FlexoBot";
import { type BotQuestion, type BotQuestionOption, BotQuestionType } from "../../../Models/Domain/FlexoBot";

class BotQuestionApiToBotQuestionTransformer implements Transformer<BotQuestionApi, Promise<BotQuestion>> {
  public async transform(botQuestionApi: BotQuestionApi): Promise<BotQuestion> {
    let botQuestionType: BotQuestionType;
    let botQuestionOptions: BotQuestionOption[] | null;

    if (botQuestionApi.question_type === BotQuestionTypeApi.MULTIPLE) {
      botQuestionType = BotQuestionType.MULTIPLE;

      if (Array.isArray(botQuestionApi.options)) {
        botQuestionOptions = botQuestionApi.options;
      } else {
        throw new Error("Error transforming BotQuestionApi to BotQuestion");
      }
    } else {
      botQuestionOptions = null;

      if ("type" in botQuestionApi.options) {
        botQuestionType = this.getKeyValueOfBotQuestionType(botQuestionApi.options.type);
      } else {
        throw new Error("Error transforming BotQuestionApi to BotQuestion");
      }
    }

    const botQuestion: BotQuestion = {
      id: botQuestionApi.uuid,
      options: botQuestionOptions,
      type: botQuestionType,
    };

    return botQuestion;
  }

  private getKeyValueOfBotQuestionType(value: string): BotQuestionType {
    const indexOfS = Object.values(BotQuestionType).indexOf(value as unknown as BotQuestionType);

    const key = Object.keys(BotQuestionType)[indexOfS];
    switch (key) {
      case "EMAIL":
        return BotQuestionType.EMAIL;
      case "PASSWORD":
        return BotQuestionType.PASSWORD;
      case "PLAIN":
        return BotQuestionType.PLAIN;
      case "PHONE":
        return BotQuestionType.PHONE;
      default:
        return BotQuestionType.MULTIPLE;
    }
  }
}

export default BotQuestionApiToBotQuestionTransformer;
